import { render, staticRenderFns } from "./HelpAdmin.vue?vue&type=template&id=641474c4&scoped=true"
import script from "./HelpAdmin.vue?vue&type=script&lang=js"
export * from "./HelpAdmin.vue?vue&type=script&lang=js"
import style0 from "./HelpAdmin.vue?vue&type=style&index=0&id=641474c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641474c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641474c4')) {
      api.createRecord('641474c4', component.options)
    } else {
      api.reload('641474c4', component.options)
    }
    module.hot.accept("./HelpAdmin.vue?vue&type=template&id=641474c4&scoped=true", function () {
      api.rerender('641474c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HelpAdmin.vue"
export default component.exports